import { render, staticRenderFns } from "./ConfirmarTelefono.vue?vue&type=template&id=87b89884&scoped=true&"
import script from "./ConfirmarTelefono.vue?vue&type=script&lang=js&"
export * from "./ConfirmarTelefono.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmarTelefono.vue?vue&type=style&index=0&id=87b89884&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b89884",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VFooter,VTextField})
